export default __webpack_public_path__ + "static/media/logo-login.2af6ecfc.svg";